var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnitTermination({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8696",
    "data-name": "Rectangle 8696",
    width: 15.942,
    height: 15.986,
    fill: "#0072ce"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Unit_Termination"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Unit_Termination",
    "data-name": "Unit Termination",
    clipPath: "url(#clip-Unit_Termination)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11772",
    "data-name": "Group 11772",
    transform: "translate(1.029 1.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11771",
    "data-name": "Group 11771",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22215",
    "data-name": "Path 22215",
    d: "M0,5.906C0,4,.007,2.088,0,.179,0,.017.078.028.184.028q4.706,0,9.412,0c.162,0,.324-.014.486-.025.121-.008.17.033.169.164-.007,1.025-.008,2.051-.01,3.076,0,.2,0,.2.2.2,1.025,0,2.051,0,3.077,0,.14,0,.162.039.16.171-.008.954-.006,1.909-.009,2.863a.234.234,0,0,0,.128.206,5,5,0,0,1,1.824,2.377,4.739,4.739,0,0,1,.319,1.55,4.991,4.991,0,0,1-2.363,4.547,5.075,5.075,0,0,1-2.36.81,4.939,4.939,0,0,1-2.951-.683A5.1,5.1,0,0,1,6.649,13.8a.242.242,0,0,0-.215-.109c-1.259,0-2.518,0-3.777,0a2.763,2.763,0,0,1-1.551-.332A2.15,2.15,0,0,1,.01,11.48c-.01-1.858,0-3.716,0-5.574Zm7.6.947c-.588,0-1.176,0-1.764,0-.116,0-.149-.038-.149-.147,0-.279,0-.559-.016-.837-.006-.12.036-.146.146-.146.67,0,1.34.005,2.01,0,.119,0,.149.04.143.149-.009.187-.009.375-.011.563,0,.1.016.16.138.083a4.485,4.485,0,0,1,.889-.425.16.16,0,0,0,.129-.173c0-.223,0-.447,0-.67-.007-1.315.017-2.629-.007-3.944,0-.119-.032-.158-.154-.155-.2.006-.406-.011-.609-.012l-6.731,0c-.122,0-.244,0-.365,0s-.158.038-.152.153c.008.157.007.315.007.472q0,4.7,0,9.4a2.576,2.576,0,0,0,.039.545,1.112,1.112,0,0,0,1.095.878q1.759,0,3.518,0c.25,0,.275.059.18-.24a4.824,4.824,0,0,1,.009-3.022A5.35,5.35,0,0,1,6.6,7.956a4.387,4.387,0,0,1,1-1.1M6.83,10.818a2.743,2.743,0,0,0,.038.652,4.018,4.018,0,0,0,.66,1.644c.094.139.1.14.219.019q.948-.957,1.9-1.913,1.742-1.745,3.489-3.486c.062-.061.076-.095,0-.15a3.893,3.893,0,0,0-1.983-.727,4.427,4.427,0,0,0-1.5.168A3.951,3.951,0,0,0,6.83,10.818m7.988.2a3.812,3.812,0,0,0-.034-.757,3.954,3.954,0,0,0-.694-1.728c-.058-.084-.087-.067-.144,0-.129.144-.263.282-.4.418q-2.518,2.51-5.038,5.018c-.063.062-.074.09.007.145a3.884,3.884,0,0,0,3.243.628,3.972,3.972,0,0,0,3.06-3.721M11.406,4.566V4.552c-.334,0-.669,0-1,0-.117,0-.161.037-.158.158q.009.448-.005.9c0,.119.032.161.154.153A5.574,5.574,0,0,1,12.425,6c.113.035.137.005.134-.105-.011-.4-.02-.8-.015-1.2,0-.1-.019-.132-.12-.131-.339,0-.679,0-1.018,0",
    transform: "translate(0 0.001)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22216",
    "data-name": "Path 22216",
    d: "M21.259,28.017c.9,0,1.8,0,2.693,0,.12,0,.165.017.16.155-.011.278,0,.557.013.836,0,.107-.034.139-.141.137-1.542-.026-3.083-.017-4.625-.016q-.4,0-.806.014c-.112,0-.151-.036-.148-.15.007-.279.009-.558,0-.837,0-.121.039-.14.147-.14.9,0,1.805,0,2.708,0",
    transform: "translate(-16.144 -24.576)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22218",
    "data-name": "Path 22218",
    d: "M19.586,84.686c-.334,0-.669,0-1,0-.1,0-.135-.027-.134-.129.005-.289,0-.577,0-.866,0-.092.021-.133.128-.133q1.01.008,2.021,0c.1,0,.139.023.135.134-.009.288-.006.577,0,.866,0,.1-.032.13-.131.129-.339-.005-.679,0-1.018,0Z",
    transform: "translate(-16.156 -75.556)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22219",
    "data-name": "Path 22219",
    d: "M19.558,46.641c.335,0,.669,0,1,0,.1,0,.135.028.128.129a6.906,6.906,0,0,0,0,.851c.005.108-.03.149-.147.148-.664-.006-1.328,0-1.993,0-.1,0-.143-.024-.14-.135.007-.289.005-.578,0-.867,0-.1.038-.129.133-.128.34,0,.679,0,1.019,0Z",
    transform: "translate(-16.146 -40.912)",
    fill: "#0072ce"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitTermination);
export default __webpack_public_path__ + "static/media/Unit Termination.3737b1d0a598c6a032cd58d756600bd4.svg";
export { ForwardRef as ReactComponent };